import React from "react";
import { Link, useLocation } from "react-router-dom";

const Navigation = () => {
  const location = useLocation();

  const navItems = [
    { path: "/games", label: "Games" },
    { path: "/contact", label: "Need Help? Contact us" }
  ];

  return (
    <ul className="dp-nav-list">
      {navItems.map((item) => (
        <li key={item.path} className="dp-nav-item">
          <Link
            className={`dp-nav-link ${location.pathname === item.path ? 'active' : ''}`}
            to={item.path}
          >
            {item.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default Navigation;
